module.exports = __webpack_public_path__ + "static/img/08-cgM.7c36fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/08-cgM.png
// module id = G/ni
// module chunks = 1